module.exports = __webpack_public_path__ + "static/media/analitics-logo.7ae88e91.png";